<svg
  class="h-auto w-full"
  [attr.viewBox]="viewBox"
  role="img"
  [attr.aria-label]="'project.steps.rfp.invitationList.matrix.title' | transloco"
  data-testid="rfp-suitability-matrix"
>
  @let area = preferredArea();
  <rect
    [attr.x]="area.x"
    [attr.y]="area.y"
    [attr.width]="area.width"
    [attr.height]="area.height"
    fill-opacity="0.08"
    style="fill: var(--color-green)"
  />
  @for (line of gridLines; track line.step) {
    <line
      [attr.x1]="plotLeft"
      [attr.x2]="plotRight"
      [attr.y1]="line.y"
      [attr.y2]="line.y"
      class="text-muted-color"
      stroke="currentColor"
      stroke-opacity="0.25"
    />
    <line
      [attr.x1]="line.x"
      [attr.x2]="line.x"
      [attr.y1]="plotTop"
      [attr.y2]="plotBottom"
      class="text-muted-color"
      stroke="currentColor"
      stroke-opacity="0.25"
    />
    <text
      [attr.x]="yTickX"
      [attr.y]="line.y + tickBaseline"
      text-anchor="end"
      class="text-muted-color text-xs"
      fill="currentColor"
    >
      {{ line.step }}
    </text>
    <text
      [attr.x]="line.x"
      [attr.y]="xTickY"
      text-anchor="middle"
      class="text-muted-color text-xs"
      fill="currentColor"
    >
      {{ line.step }}
    </text>
  }
  @let thresholdLines = thresholdPositions();
  <line
    [attr.x1]="thresholdLines.x"
    [attr.x2]="thresholdLines.x"
    [attr.y1]="plotTop"
    [attr.y2]="plotBottom"
    stroke-dasharray="6 4"
    style="stroke: var(--color-green)"
  />
  <line
    [attr.x1]="plotLeft"
    [attr.x2]="plotRight"
    [attr.y1]="thresholdLines.y"
    [attr.y2]="thresholdLines.y"
    stroke-dasharray="6 4"
    style="stroke: var(--color-green)"
  />
  <text
    [attr.x]="xAxisLabel.x"
    [attr.y]="xAxisLabel.y"
    text-anchor="middle"
    class="text-sm"
    fill="currentColor"
  >
    {{ xAxisLabelKey() | transloco }} (%) →
  </text>
  <text
    [attr.x]="yAxisLabel.x"
    [attr.y]="yAxisLabel.y"
    text-anchor="middle"
    class="text-sm"
    fill="currentColor"
    [attr.transform]="yAxisLabel.transform"
  >
    {{ 'project.steps.rfp.invitationList.matrix.axisRfi' | transloco }} (%) →
  </text>

  @for (point of points(); track point.id) {
    <g
      class="group cursor-pointer outline-none"
      tabindex="0"
      role="button"
      [attr.aria-label]="point.name"
      (click)="select(point.id)"
      (keydown.enter)="selectByKey($event, point.id)"
      (keydown.space)="selectByKey($event, point.id)"
      data-testid="matrix-point"
    >
      <title>
        {{ point.name }} · {{ 'project.steps.rfp.invitationList.matrix.coverage' | transloco }}
        {{ point.coverage | appNumber: '1.0-0' }} % · RFI {{ point.rfi | appNumber: '1.0-0' }} % ·
        {{ 'project.steps.rfp.invitationList.matrix.countries' | transloco }}
        {{ point.countryCoverage | appNumber: '1.0-0' }} % ·
        {{ 'project.steps.rfp.invitationList.matrix.dataCompleteness' | transloco }}
        {{ point.dataCompleteness | appNumber: '1.0-0' }} %
      </title>
      @if (point.displaced) {
        <line
          [attr.x1]="point.trueX"
          [attr.y1]="point.trueY"
          [attr.x2]="point.x"
          [attr.y2]="point.y"
          stroke="currentColor"
          stroke-opacity="0.45"
        />
        <circle [attr.cx]="point.trueX" [attr.cy]="point.trueY" r="2.5" fill="currentColor" />
      }
      <circle
        [attr.cx]="point.x"
        [attr.cy]="point.y"
        [attr.r]="point.radius"
        fill-opacity="0.85"
        [style.fill]="point.color"
        [style.stroke]="point.ringColor"
        [style.stroke-width]="point.ringWidth"
        class="group-focus-visible:stroke-white group-focus-visible:[stroke-width:3]"
      />
      <text
        [attr.x]="point.x"
        [attr.y]="point.numberY"
        text-anchor="middle"
        class="text-xs font-bold"
        style="fill: var(--color-first-level)"
      >
        {{ point.index }}
      </text>
      <text
        [attr.x]="point.labelX"
        [attr.y]="point.labelY"
        [attr.text-anchor]="point.labelAnchor"
        class="text-xs"
        fill="currentColor"
      >
        {{ point.label }}
      </text>
    </g>
  }
</svg>
